<!-- <myclubrewards-editable-card-header [config] = 'headingValue'></myclubrewards-editable-card-header>
<div style="display: flex;">
  <myclubrewards-card style="margin-right: 20px;" *ngFor="let config of values" [config] = 'config'></myclubrewards-card>
</div> -->
<ng-container *ngIf="giftCard$ | async as giftCard">
  <myclubrewards-editable-card-header
    [config]="giftCard"
  ></myclubrewards-editable-card-header>

  <ng-container *ngIf="giftCard.items.length">
    <!-- <div class="gift-back-wrapper"> -->
    <div class="card-wrapper">
      <div class="gift-back"></div>
      <div class="gift-card-box">
        <myclubrewards-card
          *ngFor="let item of giftCard.items"
          [config]="item"
          class="gift-card"
        ></myclubrewards-card>
      </div>
    </div>
    <!-- </div> -->
  </ng-container>
</ng-container>
